import { useEffect, useRef } from "react";
import { sendClientSideSplitTrackEvent } from "@leafly-com/split-next";

import { useSelector } from "@/redux/hooks";
import { getUserAgent } from "@/redux/selectors/userAgent";

import { getSplitKey } from "./getSplitKey";

const useTrackDispensaryPageViewSplitEvent = (properties?: {
  page: string;
  tier: string;
}) => {
  const pageViewTracked = useRef(false);
  const { isMobile } = useSelector(getUserAgent);

  useEffect(() => {
    if (!pageViewTracked.current && properties) {
      const splitKey = getSplitKey();

      sendClientSideSplitTrackEvent(
        {
          eventType: "guardrail_dispensary_pageView",
          properties: {
            isMobile: isMobile ? "true" : "false",
            ...properties,
          },
        },
        splitKey,
      );

      pageViewTracked.current = true;
    }
  }, [properties]);
};

export default useTrackDispensaryPageViewSplitEvent;
